var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"pdf-container row"},[_c('div',{ref:"pdfContainer",staticClass:"pdf-viewer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }